import { Box, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { getModificationLatestTableRows } from "./quotaModificationUtils";
import './QuotaModification.css';
import {
   Button,
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextareaAutosize, IconButton, useMediaQuery,
} from '@mui/material';
import CommentIcon from '@mui/icons-material/Comment';
import { useTheme } from "@mui/material/styles";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import CollapseSection from "../../../components/ui/CollapseSection";

const DisplayComments = (params) => {
   const [displayComments, setDisplayComments] = useState("");
   const [userComments, setUserComments] = useState("");
   const [open, setOpen] = useState(false);
   const desiredcolor =
       params?.comments?.length > 0 &&
           params?.comments != "Default Customer quota record"
           ? "blue"
           : "black";

   const theme = useTheme();
   const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

   const handleClose = () => {
       setOpen(false);
   };

   return (
       <>
           <IconButton
               onClick={() => setOpen(true)}
               title={params.comments}
           >
               {params?.comments ? (
                   <ForumOutlinedIcon title={params.comments} sx={{ color:"#007DC3" }}/>
               ) : (
                   <ForumOutlinedIcon />
               )}
           </IconButton>

           <Dialog
               disableEnforceFocus
               fullScreen={fullScreen}
               open={open}
               onClose={handleClose}
               aria-labelledby="responsive-dialog-title"
           >
               <DialogTitle id="responsive-dialog-title">Comments</DialogTitle>
               <DialogContent>
                   <DialogContentText>
                       <TextareaAutosize
                           onChange={(event) => setUserComments(event.target.value)}
                           aria-label="minimum height"
                           minRows={5}
                           readOnly
                           placeholder=""
                           style={{ width: 500, fontSize: 18 }}
                           defaultValue={params.comments}
                       />
                   </DialogContentText>
               </DialogContent>
               <DialogActions>
                   <Button
                       variant="outlined"
                       onClick={handleClose}
                       size="small"
                       style={{
                           background: "#286aa6",
                           color: "white",
                           borderRadius: "4px",
                       }}
                   >
                       Cancel
                   </Button>
               </DialogActions>
           </Dialog>
       </>
   );
};
function getModificationLatestTableCols(depletionModel) {
   const w = 150;
   if(depletionModel?.toLowerCase() === "none" ){
      const columns = [
         { field: "modificationNo", headerName: "Modification No", flex:1 },
         { field: "customerName", headerName: "Customer/CG", flex:1 },
         { field: "number", headerName: "Customer Number", flex:1 },
         { field: "skuName", headerName: "SKU/PG", flex:1},
         { field: "skuNumb", headerName: "SKU Number", flex:1 },
         { field: "modification1", headerName: "Quota", flex:1 , 
            valueFormatter: (params) => {
               const formattedValue = params.value?.toLocaleString();
               return formattedValue;
            },
            cellClassName : (params) =>{
            const currentRowIdx = params.id;
            const Row = params.api.getRow(currentRowIdx);
            if(Row === undefined) return '';
            if(Row.modification1 !== Row.priorModification1){
               return 'red-row';
            }
            return '';
         } },
         { field: "modificationComments", headerName: "Comments", flex:1 ,
         renderCell: (cellValues) => {
            return <DisplayComments readonly comments={cellValues.value} />;
         },},
      ];
      return columns;
   }
   else if(depletionModel?.toLowerCase() === "biweekly" ){
      const columns = [
         { field: "modificationNo", headerName: "Modification No", flex:1 },
         { field: "customerName", headerName: "Customer/CG", flex:1 },
         { field: "number", headerName: "Customer Number", flex:1 },
         { field: "skuName", headerName: "SKU/PG", flex:1 },
         { field: "skuNumb", headerName: "SKU Number", flex:1 },
         { field: "modification1", headerName: "First Half", flex:1 , 
            valueFormatter: (params) => {
               const formattedValue = params.value?.toLocaleString();
               return formattedValue;
            },
            cellClassName : (params) =>{
            const currentRowIdx = params.id;
            const Row = params.api.getRow(currentRowIdx);
            if(Row === undefined) return '';
            if(Row.modification1 !== Row.priorModification1){
               return 'red-row';
            }
            return '';
         } },
         { field: "modification2", headerName: "Second Half", flex:1 , 
            valueFormatter: (params) => {
               const formattedValue = params.value?.toLocaleString();
               return formattedValue;
            },
            cellClassName : (params) =>{
            const currentRowIdx = params.id;
            const Row = params.api.getRow(currentRowIdx);
            if(Row === undefined) return '';
            if(Row.modification2 !== Row.priorModification2){
               return 'red-row';
            }
            return '';
         } },
   
         { field: "modificationComments", headerName: "Comments", flex:1 ,
         renderCell: (cellValues) => {
            return <DisplayComments readonly comments={cellValues.value} />;
         },},
      ];
      return columns;
   }else{
      const columns = [
         { field: "modificationNo", headerName: "Modification No", flex:1 },
         { field: "customerName", headerName: "Customer/CG", flex:1 },
         { field: "number", headerName: "Customer Number", flex:1 },
         { field: "skuName", headerName: "SKU/PG", flex:1 },
         { field: "skuNumb", headerName: "SKU Number", flex:1 },
         { field: "modification1", headerName: "Week 1", flex:1 , 
            valueFormatter: (params) => {
               const formattedValue = params.value?.toLocaleString();
               return formattedValue;
            },
            cellClassName : (params) =>{
            const currentRowIdx = params.id;
            const Row = params.api.getRow(currentRowIdx);
            if(Row === undefined) return '';
            if(Row.modification1 !== Row.priorModification1){
               return 'red-row';
            }
            return '';
         } },
         { field: "modification2", headerName: "Week 2", flex:1 , 
            valueFormatter: (params) => {
               const formattedValue = params.value?.toLocaleString();
               return formattedValue;
            },
            cellClassName : (params) =>{
            const currentRowIdx = params.id;
            const Row = params.api.getRow(currentRowIdx);
            if(Row === undefined) return '';
            if(Row.modification2 !== Row.priorModification2){
               return 'red-row';
            }
            return '';
         } },
         { field: "modification3", headerName: "Week 3", flex:1 , 
            valueFormatter: (params) => {
               const formattedValue = params.value?.toLocaleString();
               return formattedValue;
            },
            cellClassName : (params) =>{
            const currentRowIdx = params.id;
            const Row = params.api.getRow(currentRowIdx);
            if(Row === undefined) return '';
            if(Row.modification3 !== Row.priorModification3){
               return 'red-row';
            }
            return '';
         } },
         { field: "modification4", headerName: "Week 4", flex:1 , 
            valueFormatter: (params) => {
               const formattedValue = params.value?.toLocaleString();
               return formattedValue;
            },
            cellClassName : (params) =>{
            const currentRowIdx = params.id;
            const Row = params.api.getRow(currentRowIdx);
            if(Row === undefined) return '';
            if(Row.modification4 !== Row.priorModification4){
               return 'red-row';
            }
            return '';
         } },
         { field: "modification5", headerName: "Week 5", flex:1 ,
            valueFormatter: (params) => {
               const formattedValue = params.value?.toLocaleString();
               return formattedValue;
            },
            cellClassName : (params) =>{
            const currentRowIdx = params.id;
            const Row = params.api.getRow(currentRowIdx);
            if(Row === undefined) return '';
            if(Row.modification5 !== Row.priorModification5){
               return 'red-row';
            }
            return '';
         } 
      },
         { field: "modificationComments", headerName: "Comments", flex:1 ,
         renderCell: (cellValues) => {
            return <DisplayComments readonly comments={cellValues.value} />;
         },},
      ];
      return columns;
   }
}

// function getCellClassName(params){
//    const state = useSelector((store) => store.quotaModification);
//    const { modificationPriorChanges } = state;
//    const currentRowIdx = params.id;
//    const Row = params.api.getRow(currentRowIdx);
//    if(Row === undefined) return '';
//    const prior = modificationPriorChanges;
//    const priorChanges = prior.find((x)=> x.customerName === Row.customerName && x.skuName === Row.skuName &&
//    x.modificationNo === Row.modificationNo);
//    if(priorChanges === undefined) return '';
//    if(Row.modification5 !== priorChanges.modification5){
//       return 'red-row';
//    }
//    return '';
// }

export default function ModificationLatestTable() {
   const state = useSelector((store) => store.quotaModification);
   const { scenarioModificationList, selectedRows, displayModifiedRecords,scenarioName, selectedModificationNumber } = state;

   const [paginationModel, setPaginationModel] = useState({
      pageSize: 20,
      page: 0,
   });

   if(scenarioModificationList === null) return null;

   // const rows = getModificationLatestTableRows(
   //    scenarioModificationList[selectedRows[selectedRows.length - 1]].modificationCustomersPriorChanges,
   //    scenarioModificationList[selectedRows[selectedRows.length - 1]].modificationCustomersLatestChanges,
   //    displayModifiedRecords
   // );
   let modificationNo = ""
   if(selectedModificationNumber === null || selectedModificationNumber === undefined ||selectedModificationNumber === ""){
      modificationNo = scenarioModificationList[0].modificationNo 
   }else{
      modificationNo = selectedModificationNumber;
   }
   const rows = getModificationLatestTableRows(
      scenarioModificationList[0].modificationCustomersPriorChanges,
      scenarioModificationList[0].modificationCustomersLatestChanges,
      displayModifiedRecords,modificationNo
   );
   const columns = getModificationLatestTableCols(scenarioModificationList[0].depletionModel);
   const title = `Quota Modification of : ${scenarioName}`

   return (
      <Box sx={{ mt: 3 }}>
            {/* <Typography  className="compHeading" sx={{mb: 2, fontWeight:600, }} >Quota Modification of: {scenarioName}</Typography> */}
         <CollapseSection title={title}>
         <DataGrid style={{ maxHeight: 'calc(100vh - 130px)', mt: 5,}}
            rows={rows}
            columns={columns}
            sx={{
					'& .MuiDataGrid-cell': {
					  whiteSpace: 'normal !important',
					  wordWrap: 'break-word !important',
					}}}
            disableRowSelectionOnClick
            disableColumnMenu
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            pageSizeOptions={[20, 50, 100]}
            headerHeight={40} 
         />
         </CollapseSection>
      </Box>
   );
}
